var _defs, _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatedLogoC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 6387.58 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#FINAL_GRADIENT-2);}.cls-2{fill:#fff;}.cls-3{fill:url(#FINAL_GRADIENT);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FINAL_GRADIENT",
    x1: 3839.94,
    y1: 400.2,
    x2: 6106.69,
    y2: 400.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67c84d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5fc261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4db295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2f99e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9d56ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e24ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e34cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e74cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ea4ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f74666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff6c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffb200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FINAL_GRADIENT-2",
    x1: 1,
    y1: 400,
    x2: 849.59,
    y2: 400,
    xlinkHref: "#FINAL_GRADIENT"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M997.15,155.78h69.83v428.07h264.66v60.75h-334.5V155.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1411.95,155.78h69.83v488.83h-69.83V155.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1583.73,588.74l25.84-54.47c36.31,32.82,98.46,56.56,161.31,56.56,84.5,0,120.81-32.82,120.81-75.42,0-119.41-296.09-43.99-296.09-225.56,0-75.42,58.66-139.67,187.15-139.67,57.26,0,116.62,15.36,157.12,43.3l-23.05,55.87c-42.6-27.23-90.78-39.8-134.08-39.8-83.1,0-118.71,34.92-118.71,77.51,0,119.41,296.09,44.69,296.09,224.16,0,74.72-60.06,138.97-189.25,138.97-74.72,0-148.05-25.14-187.15-61.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2152.15,216.54h-167.6v-60.75h404.33v60.75h-167.6v428.07h-69.13V216.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2464.99,155.78h69.83v488.83h-69.83V155.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3101.86,155.78v488.83h-57.26l-293.3-364.52v364.52h-69.83V155.78h57.26l293.3,364.52V155.78h69.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3587.19,397.4h67.04v190.64c-48.88,41.2-116.62,62.15-185.06,62.15-150.14,0-260.47-105.45-260.47-250s110.33-250,261.87-250c77.51,0,143.16,25.84,187.85,75.42l-43.3,43.3c-40.5-39.11-86.59-56.56-141.76-56.56-113.13,0-194.83,78.91-194.83,187.85s81.7,187.85,194.13,187.85c41.2,0,79.61-9.08,114.53-31.42v-159.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4032,166.78h-192.06v466.82h86.7v-134.71h105.37c122.71,0,198.73-63.35,198.73-166.05s-76.02-166.06-198.73-166.06Zm-4,258.75h-101.37V240.14h101.37c76.02,0,115.37,34.01,115.37,92.7s-39.35,92.7-115.37,92.7Zm410.14-258.75l-210.07,466.82h89.36l46.02-108.04h233.41l46.68,108.04h90.7l-210.74-466.82h-85.36Zm-45.35,290.76l87.36-204.07,88.03,204.07h-175.39Zm791.6-124.71c0-103.37-76.03-166.06-198.73-166.06h-192.06v466.82h86.7v-136.04h105.37c6,0,12,0,18.01-.67l95.37,136.71h93.36l-107.37-153.38c63.36-24.68,99.37-76.69,99.37-147.38Zm-202.73,93.37h-101.37V240.14h101.37c76.03,0,115.37,34.01,115.37,92.7s-39.35,93.37-115.37,93.37Zm232.74-259.42h396.13v73.36h-154.72v393.46h-86.7V240.14h-154.72v-73.36Zm892.3,0l-182.73,302.1v164.72h-86.7v-163.39l-183.39-303.43h92.7l136.71,227.41,138.05-227.41h85.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6213.44,179.68h-33.59v-12.18h81.04v12.18h-33.59v85.8h-13.86v-85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6366.98,265.48l-.14-71.38-35.41,59.48h-6.44l-35.41-59.06v70.96h-13.44v-97.97h11.48l40.87,68.86,40.31-68.86h11.48l.14,97.97h-13.44Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.5,339.33c-1.17-30.38-14.03-58.56-36.21-79.35L567.44,34.91l-.07-.07c-23.1-20.68-52.88-31.22-83.84-29.69-30.97,1.53-59.55,14.96-80.45,37.76l-208.11,223.26c-17.56-8.24-37.41-11.1-56.63-8.04-21.51,3.42-41.47,14.13-56.18,30.11l-55.27,59.25c-36.43,39.28-34.12,100.87,5.16,137.3l213.8,194.33c19.06,17.01,43.19,25.62,67.4,25.62,19.07,0,38.19-5.35,54.89-16.15l93.46,83.82c16.58,14.64,37.58,22.57,59.56,22.57,1.43,0,2.86-.03,4.3-.1,23.53-1.1,45.36-11.17,61.5-28.37l66.26-71.12c16.03-16.93,24.63-39.99,23.61-63.28-.18-15.22-4.27-29.95-11.89-42.99l154.59-167.91c20.51-22.44,31.16-51.53,29.99-81.9Zm-280.8,15.53c.04,3.97-1.35,7.8-3.92,10.82l-227.42,237.14-14.31,14.31c-6.01,5.13-14.95,5.09-20.91-.12L90.39,424.23c-4.43-5.24-4.34-12.95,.26-18.1l52.86-60.79c5.75-5.38,14.59-5.31,20.26,.22l144,130.12,176.42-182.82c6.37-6.2,16.67-6.18,23.01,.07l57.21,52.34c2.31,2.14,3.85,5.02,4.37,8.12l-.1,.47v1Zm58.38,61.67c17.81-18.22,27.94-42.28,28.52-67.75v-.4s-.02-.39-.02-.39c-1.74-25.89-13.26-49.79-32.42-67.29l-58.75-54.78-.1-.09c-19.69-17.77-45.13-26.96-71.62-25.87-26.5,1.09-51.09,12.34-69.23,31.65l-119.58,126.32-42.5-39.44L464.36,99.19c12.85-12.41,32.91-13.31,46.83-2.13l245.15,223.51c6.24,5.67,9.94,13.43,10.41,21.88,.49,8.48-2.53,16.93-8.3,23.17l-209.37,227.57,43.01,38.35c1.68,1.93,1.63,4.82-.17,6.69l-66.13,71.42c-2.42,2.04-5.93,1.98-8.29-.19l-89.82-82.4,199.39-210.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedLogoC);
export default __webpack_public_path__ + "static/media/updatedLogoC.00f8acf6c425f568c3d890f8582b1114.svg";
export { ForwardRef as ReactComponent };